import {FC, useEffect, useState} from "react";
import TestStats from "@/components/dashboard/TestStats";
import TotalCosts from "@/components/dashboard/TotalCosts";
import CostDetails from "@/components/dashboard/CostDetails";
import CodeReview from "@/components/dashboard/CodeReview";
import GeneralVue from "@/components/dashboard/GeneralVue";
import CreateProjectCard from "@/components/dashboard/CreateProjectCard";
import DashboardLayout from "@/components/layouts/Dashboard";
import {apiGetDashboardData} from '@/services/HomeService';
import {DashboardData} from "@/@types/home";
import Skeleton from "@/components/ui/Skeleton";
import Card from "@/components/Card";

interface DashboardProps {
}

const Dashboard: FC<DashboardProps> = () => {
  const [dashboardData, setDashboardData] = useState<DashboardData | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(true);

  const getDashboardData = () => {
    setLoading(true)
    apiGetDashboardData().then((response) => {
      setDashboardData(response.data);
    }).catch((_error) => {
      
    }).finally(() => {
      setLoading(false);
    });
  }

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
      <DashboardLayout>
        <div className="w-full max-w-7xl m-auto grid grid-cols-12 gap-3 grow">
          {(!loading) && (<>
            <div className="xl:col-span-9 lg:col-span-8 col-span-12">
              <CreateProjectCard/>
              <GeneralVue generalProgressData={dashboardData?.generalProgress}
                          shredsProgressData={dashboardData?.shredsProgress}/>

            </div>
            <div className="xl:col-span-3 lg:col-span-4 col-span-12">
              <TotalCosts shreddingCoins={dashboardData?.shreddingCoins}/>
              <TestStats shredsTestsData={dashboardData?.shredsTests}/>
            </div>
            <div className="xl:col-span-3 col-span-12">
              <CodeReview projectStatusData={dashboardData?.codeReviews}/>
            </div>
            <div className="xl:col-span-9 col-span-12">
              <CostDetails costDetailsData={dashboardData?.costDetails}/>
            </div>
          </>)}
          {(loading) && (<>
            <div className="xl:col-span-9 lg:col-span-8 col-span-12">
              <Skeleton height={344} className="px-1 xl:px-5 mb-5 rounded-3xl"/>
              <Skeleton height={557} className="px-1 xl:px-5 mb-4 rounded-3xl"/>
            </div>
            <div className="xl:col-span-3 lg:col-span-4 col-span-12">
              <Skeleton height={375} className="px-1 xl:px-5 mb-5 rounded-3xl"/>
              <Skeleton height={224} className="px-1 xl:px-5 mb-5 rounded-3xl"/>
            </div>
            <div className="xl:col-span-3 col-span-12">
              <Skeleton height={544} className="px-1 xl:px-5 mb-5 rounded-3xl"/>
            </div>
            <div className="xl:col-span-9 col-span-12">
              <Card borderColor="transparent" bgColor="transparent" minHeight="[510px]">
                <Skeleton height={504} className="px-1 xl:px-5 grid grid-cols-12 rounded-3xl"/>
              </Card>
            </div>
          </>)}
        </div>
      </DashboardLayout>
  );
};

export default Dashboard;
